import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DesktopScreen, MobileTabletScreen } from '@sm/webassets';

import { NAV_VARIANT } from '../../enums';
import getBrowser, { BROWSER } from '../../helpers/getBrowser';
import NavForDesktop, { TEST_ID as DESKTOP_TEST_ID } from './NavForDesktop';
import NavForTablet, { TEST_ID as TABLET_TEST_ID } from './NavForTablet';
import NavForIE, {
  DESKTOP_TEST_ID as IE_DESKTOP_TEST_ID,
  MOBILE_TEST_ID as IE_MOBILE_TEST_ID
} from './NavForIE';
import './mrx-nav.scss';

export const TEST_ID = {
  DESKTOP: DESKTOP_TEST_ID,
  TABLET: TABLET_TEST_ID,
  IE_DESKTOP: IE_DESKTOP_TEST_ID,
  IE_TABLET: IE_MOBILE_TEST_ID
};

const MRXNav = ({ variant, mobileOpen, setMobileOpen }) => {
  const [openMenu, _setOpenMenu] = useState(undefined);
  const setOpenMenu = menu => {
    if (menu === openMenu) _setOpenMenu(undefined);
    else _setOpenMenu(menu);
  };
  const isIE11 = getBrowser() === BROWSER.IE;

  return (
    <Choose>
      <When condition={!isIE11}>
        <DesktopScreen>
          <NavForDesktop
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            variant={variant}
          />
        </DesktopScreen>
        <MobileTabletScreen>
          <NavForTablet
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            isOpen={mobileOpen}
            setIsOpen={setMobileOpen}
          />
        </MobileTabletScreen>
      </When>
      <Otherwise>
        <NavForIE
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          isOpen={mobileOpen}
          setIsOpen={setMobileOpen}
          variant={variant}
        />
      </Otherwise>
    </Choose>
  );
};

MRXNav.propTypes = {
  variant: PropTypes.oneOf(Object.values(NAV_VARIANT)),
  mobileOpen: PropTypes.bool.isRequired,
  setMobileOpen: PropTypes.func.isRequired
};

MRXNav.defaultProps = {
  variant: NAV_VARIANT.LIGHT
};

export default MRXNav;
